import React, { useEffect } from 'react';

import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';

import { AuthCheck } from '@/modules/access/api/auth';

export default function TemplateDemo({
  isMobile,
  onClickMobileMenu,
  headerTitle,
  showUpdateShortcut = false,
  onOpenUpdateShortcut,
}) {
  const [isAuth, setIsAuth] = React.useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const auth = await AuthCheck();
      setIsAuth(auth);
    };
    checkAuth();
  }, [isAuth]);

  const mobileStartContent = (
    <>{isAuth && <Button icon="pi pi-bars" text raised onClick={onClickMobileMenu}></Button>}</>
  );

  const centerContent = (
    <>
      <span className="title font-bold	text-700">{headerTitle ?? ''}</span>
      {/* headerTitle ??  */}
      {/* <img alt="logo" className="hidden md:block" src="/logo-la-mundial.png" height="40"></img>
      <img alt="logo" className="md:hidden" src="/isotipo-la-mundial.png" height="40"></img> */}
    </>
  );
  const endContent = (
    <>
      {showUpdateShortcut && (
        <div
          className="topbar-update-wrapper"
          style={{ position: 'relative', display: 'inline-block' }}
        >
          <Button
            icon="pi pi-megaphone"
            size="large"
            className="p-button-rounded p-button-lg topbar-update-button"
            style={{ backgroundColor: '#0f8fa8', borderColor: '#0f8fa8', color: '#ffffff' }}
            onClick={onOpenUpdateShortcut}
            tooltip="Ver novedades"
            tooltipOptions={{ position: 'bottom' }}
            aria-label="Ver novedades"
          />
        </div>
      )}
      <img alt="logo" src="/logo.png" height="40" className="hidden md:block mr-2"></img>
    </>
  );

  return (
    <div className="card">
      <style>{`
        .topbar-update-wrapper { margin-right: 8px; }
        .topbar-update-button { position: relative; overflow: visible; background-color: #0f8fa8 !important; border-color: #0f8fa8 !important; color: #ffffff !important; transition: box-shadow 160ms ease, transform 160ms ease, filter 160ms ease; }
        .topbar-update-button .p-button-icon { color: #ffffff !important; }
        .topbar-update-button:hover { box-shadow: 0 8px 20px rgba(15,143,168,0.18); transform: translateY(-2px); filter: brightness(1.03); }
      `}</style>

      <Toolbar
        start={isMobile ? mobileStartContent : undefined}
        center={centerContent}
        end={endContent}
      />
    </div>
  );
}
